import React from 'react';
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import { useCart } from '../context/CartContext';

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [showNotification, setShowNotification] = useState(false);

  const products = {
    '1': {
      id: 1,
      name: 'Κλασική Κρέμα Ξυρίσματος Premium',
      description: 'Η premium κρέμα ξυρίσματος Ferupen είναι το απόλυτο όπλο για ένα τέλειο, απαλό και χωρίς ερεθισμούς ξύρισμα. Εμπλουτισμένη με φυσικά έλαια και εκχυλίσματα βοτάνων, δημιουργεί έναν πλούσιο αφρό που προστατεύει το δέρμα και διευκολύνει το ξύρισμα. Η μοναδική φόρμουλά της περιέχει αλόη βέρα, βιταμίνη Ε και γλυκερίνη που ενυδατώνουν βαθιά και αφήνουν το δέρμα απαλό σαν μετάξι.',
      price: 45.99,
      image: '/images/1.jpg',
      features: [
        'Φυσικά συστατικά χωρίς parabens',
        'Πλούσιος αφρός για τέλεια λείανση',
        'Κατάλληλη για όλους τους τύπους δέρματος',
        'Αρωματισμένη με κλασικό άρωμα sandalwood',
        'Δοκιμασμένη δερματολογικά',
        'Φιλική προς το περιβάλλον συσκευασία'
      ]
    },
    '2': {
      id: 2,
      name: 'Έλαιο Περιποίησης Μούσι Deluxe',
      description: 'Το Deluxe Beard Oil του Ferupen είναι ένα εξαιρετικό μείγμα φυσικών ελαίων που σχεδιάστηκε ειδικά για να θρέψει, να μαλακώσει και να δώσει λάμψη στο μούσι σας. Περιέχει έλαιο αργκάν, jojoba και αμυγδάλου που διεισδύουν βαθιά στην τρίχα και το δέρμα, εξαλείφοντας την ξηρότητα και το κνησμό. Το λεπτό άρωμα cedarwood και bergamot σας κρατά φρέσκο όλη την ημέρα.',
      price: 38.50,
      image: '/images/2.jpg',
      features: [
        '100% φυσικά οργανικά έλαια',
        'Μαλακώνει και θρέφει το μούσι',
        'Εξαλείφει τον κνησμό του δέρματος',
        'Προσθέτει υγιή λάμψη',
        'Γρήγορη απορρόφηση χωρίς λιπαρότητα',
        'Πλούσιο άρωμα που διαρκεί'
      ]
    },
    '3': {
      id: 3,
      name: 'Κερί Μαλλιών Ματ Φινίρισμα',
      description: 'Το επαγγελματικό κερί μαλλιών Ferupen προσφέρει extra strong κράτημα με φυσικό ματ φινίρισμα. Ιδανικό για όλα τα στυλ, από κλασικά μέχρι σύγχρονα, παρέχει ευελιξία στο styling χωρίς να αφήνει υπολείμματα. Η φόρμουλά του εμπλουτισμένη με beeswax και καρναούβα διατηρεί το στυλ σας άψογο όλη την ημέρα, ενώ ταυτόχρονα θρέφει τα μαλλιά χάρη στις προσθήκες βιταμίνης Ε και πρωτεΐνης.',
      price: 32.00,
      image: '/images/3.jpg',
      features: [
        'Extra strong κράτημα',
        'Φυσικό ματ φινίρισμα',
        'Εύκολη εφαρμογή και styling',
        'Δεν αφήνει υπολείμματα',
        'Κατάλληλο για όλα τα μήκη μαλλιών',
        'Ξεβγαίνει εύκολα με νερό'
      ]
    },
    '4': {
      id: 4,
      name: 'Αφρόλουτρο Gentleman Sandalwood',
      description: 'Το premium αφρόλουτρο Gentleman από το Ferupen είναι μια πολυτελής εμπειρία καθαρισμού. Εμπλουτισμένο με εκχύλασμα ξύλου σανταλιού και φυσικούς καθαριστικούς παράγοντες, καθαρίζει απαλά χωρίς να αφαιρεί τα φυσικά έλαια του δέρματος. Η κρεμώδης υφή του δημιουργεί πλούσιο αφρό που αφήνει την επιδερμίδα φρέσκια, ενυδατωμένη και λεπτά αρωματισμένη με την κλασική ανδρική μυρωδιά του sandalwood.',
      price: 28.75,
      image: '/images/4.jpg',
      features: [
        'Πλούσιος αφρός με λίγη ποσότητα',
        'Φυσικοί καθαριστικές παράγοντες',
        'Ενυδατώνει και θρέφει το δέρμα',
        'Κλασικό άρωμα sandalwood',
        'Χωρίς θειικά και parabens',
        'Κατάλληλο για καθημερινή χρήση'
      ]
    },
    '5': {
      id: 5,
      name: 'Σετ Περιποίησης Barbershop Essentials',
      description: 'Το πλήρες σετ Barbershop Essentials του Ferupen περιλαμβάνει όλα όσα χρειάζεται ο σύγχρονος κύριος για την καθημερινή του περιποίηση. Το σετ αποτελείται από κρέμα ξυρίσματος premium, έλαιο μούσι deluxe, κερί μαλλιών professional, αφρόλουτρο gentleman και after shave balm. Όλα τα προϊόντα είναι συσκευασμένα σε ένα κομψό δερμάτινο νεσεσέρ, ιδανικό για ταξίδια ή δώρο. Εξοικονομήστε 20% σε σχέση με την ξεχωριστή αγορά.',
      price: 89.99,
      image: '/images/5.jpg',
      features: [
        'Πλήρες σετ 5 premium προϊόντων',
        'Κομψό δερμάτινο νεσεσέρ',
        'Εξοικονόμηση 20% σε σχέση με ξεχωριστή αγορά',
        'Ιδανικό για ταξίδια',
        'Τέλειο δώρο για άνδρες',
        'Όλα τα προϊόντα full size'
      ]
    }
  };

  const product = products[id];

  if (!product) {
    return (
      <div className="product-detail-container">
        <h1>Το προϊόν δεν βρέθηκε</h1>
        <button onClick={() => navigate('/')} className="continue-shopping-btn">
          Επιστροφή στην Αρχική
        </button>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product, quantity);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleBuyNow = () => {
    addToCart(product, quantity);
    navigate('/checkout');
  };

  return (
    <>
      <Helmet>
        <title>{product.name} - Ferupen Barbershop</title>
        <meta name="description" content={product.description} />
        <meta property="og:title" content={product.name} />
        <meta property="og:description" content={product.description} />
        <meta property="og:image" content={`https://ferupen.com${product.image}`} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": product.name,
            "description": product.description,
            "image": `https://ferupen.com${product.image}`,
            "offers": {
              "@type": "Offer",
              "price": product.price,
              "priceCurrency": "EUR",
              "availability": "https://schema.org/InStock"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "reviewCount": "127"
            }
          })}
        </script>
      </Helmet>

      {showNotification && (
        <div className="notification">
          Το προϊόν προστέθηκε στο καλάθι σας!
        </div>
      )}

      <div className="product-detail-container">
        <div className="product-detail-grid">
          <div>
            <img 
              src={product.image} 
              alt={product.name} 
              className="product-detail-image"
            />
          </div>

          <div className="product-detail-info">
            <h1>{product.name}</h1>
            
            <div className="product-detail-rating">
              {[...Array(5)].map((_, index) => (
                <FaStar key={index} />
              ))}
              <span>(5.0 - 127 Αξιολογήσεις)</span>
            </div>

            <p className="product-detail-price">€{product.price.toFixed(2)}</p>

            <p className="product-detail-description">{product.description}</p>

            <div className="product-detail-features">
              <h3>Χαρακτηριστικά</h3>
              <ul>
                {product.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className="quantity-selector">
              <label htmlFor="quantity">Ποσότητα:</label>
              <input
                type="number"
                id="quantity"
                min="1"
                max="10"
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value))}
              />
            </div>

            <div className="product-actions">
              <button onClick={handleAddToCart} className="add-to-cart-btn">
                Προσθήκη στο Καλάθι
              </button>
              <button onClick={handleBuyNow} className="buy-now-btn">
                Αγορά Τώρα
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductDetail;